Greenmile.Components.ChangePassword = (function () {

    return function (entity) {

        this.onChangePassword = null;
        this.entity = entity;


        this.createHtml = function () {
            this.contentDiv = document.createElement('div');
            this.contentDiv.className = 'changePasswordContainer';

            this.headerDiv = document.createElement('div');
            this.headerDiv.className = 'changePasswordHeader';

            this.errorDiv = document.createElement('div');
            this.errorDiv.className = 'passwordErrorToChange';

            this.formDiv = document.createElement('div');
            this.formDiv.className = 'changePasswordFormContainer';

            this.headerLabel = document.createElement('h3');
            this.loginLabel = document.createElement('label');
            this.loginField = document.createElement('input');
            this.currentLabel = document.createElement('label');
            this.currentField = document.createElement('input');
            this.newLabel = document.createElement('label');
            this.newField = document.createElement('input');
            this.newConfirmLabel = document.createElement('label');
            this.newConfirmField = document.createElement('input');

            this.headerLabel.innerHTML = Monet.I18n.getResourcesByKey('users.changePasswordHeader.label');
            this.loginLabel.innerHTML = Monet.I18n.getResourcesByKey('users.login');
            this.currentLabel.innerHTML = Monet.I18n.getResourcesByKey('user.changePassword.oldPassword');
            this.newLabel.innerHTML = Monet.I18n.getResourcesByKey('user.changePassword.newPassword');
            this.newConfirmLabel.innerHTML = Monet.I18n.getResourcesByKey('user.changePassword.confirmNewPassword');

            this.loginField.type = 'text';
            this.currentField.type = 'password';
            this.newField.type = 'password';
            this.newField.className = 'newPasswordInput'
            this.newConfirmField.type = 'password';

            this.headerDiv.appendChild(this.headerLabel);

            this.formDiv.appendChild(this.currentLabel);
            this.formDiv.appendChild(this.currentField);
            this.formDiv.appendChild(this.newLabel);
            this.formDiv.appendChild(this.newField);
            this.formDiv.appendChild(this.newConfirmLabel);
            this.formDiv.appendChild(this.newConfirmField);

            this.buttonDiv = document.createElement('div');
            this.buttonDiv.className = 'changePasswordButtonContainer standard-form-buttons';

            this.changePassBtn = document.createElement('input');
            this.cancelBtn = document.createElement('input');

            this.changePassBtn.type = 'button';
            this.cancelBtn.type = 'button';

            this.changePassBtn.value = Monet.I18n.getResourcesByKey('user.changePassword.sendNewPasswordBtn');
            this.cancelBtn.value = Monet.I18n.getResourcesByKey('general.button.cancel');

            this.changePassBtn.className = 'change-password';
            this.cancelBtn.className = 'cancel';

            this.changePassBtn.disabled = true;
            this.buttonDiv.appendChild(this.changePassBtn);
            this.buttonDiv.appendChild(this.cancelBtn);

            this.contentDiv.appendChild(this.headerDiv);

            this.contentDiv.appendChild(this.errorDiv);
            this.contentDiv.appendChild(this.formDiv);
            this.contentDiv.appendChild(this.buttonDiv);
        };

        this.toogleLoading = (show) => {
            if(show) {
                this.changePassBtn.classList.add('change-password-loading');
                this.changePassBtn.classList.remove('allHintsValid');
                this.changePassBtn.value = Monet.I18n.getResourcesByKey('user.changePassword.saving');
                this.changePassBtn.disabled = true;

            } else {
                this.changePassBtn.classList.remove('change-password-loading');
                this.changePassBtn.value = Monet.I18n.getResourcesByKey('user.changePassword.sendNewPasswordBtn');
                this.changePassBtn.disabled = false;
            }
        }
        

        this.addEvents = function () {
            this.changePassBtn.addEventListener('click', (function (e) {
                this.sendNewPassword(this);
                e.stopPropagation();
            }).bind(this));
        };

        this.validateForm = function () {
            if (this.newField.value.trim() === "" && this.newConfirmField.value.trim() === "") {
                return false;
            } else {
                if (this.newField.value.trim() !== this.newConfirmField.value.trim()) {
                    return false;
                } else {
                    if (this.newField.value.trim() === '' && this.newConfirmField.value.trim() === '') {
                        return false;
                    }
                }
            }

            return true;
        };

        this.sendNewPassword = (function () {
            var isValid = this.validateForm(this),
                request = null,
                formData = {
                    login: null,
                    oldPassword: null,
                    password: null,
                    passwordConfirmation: null
                };

            this.toogleLoading(true);
            
            if (isValid) {

                formData.login = this.loginField.value;
                formData.oldPassword = this.currentField.value;
                formData.password = this.newField.value;
                formData.passwordConfirmation = this.newConfirmField.value;

                request = new Monet.Ajax();
                request.url = 'User/ChangePassword';
                request.data = formData;
                request.method = 'post';

                request.success = (function () {
                    this.passwordReseted(this);
                }).bind(this);

                request.error = (function (e) {
                    this.passwordResetError(e);
                }).bind(this);

                request.send();
            } else {
                this.errorDiv.innerHTML = Monet.I18n.getResourcesByKey('user.changePassword.formValuesAreInvalid');

                this.errorDiv.style.display = 'block';
                this.toogleLoading(false);
            }
        }).bind(this);

        this.passwordReseted = (function () {
            this.currentField.value = '';
            this.newField.value = '';
            this.newConfirmField.value = '';

            this.toogleLoading(false);
            this.errorDiv.style.display = 'none';
            this.contentDiv.style.display = 'none';
            
            if (!!this.onChangePassword && typeof this.onChangePassword === "function") {
                this.onChangePassword();
            }

        }).bind(this);

        this.passwordResetError = function (e) {
            var message = JSON.parse(e.responseText);

            this.errorDiv.innerHTML = Monet.Form.Messages.getErrorMessageToBeDisplayed(message.errorMessages);
            this.errorDiv.style.display = 'block';
            this.toogleLoading(false);
        };

        this.createPasswordValidator = function () {

            //por algum motivo desconhecido ate o momento, o this.loginField.value estava vindo 'undefined' (string)

            if (this.contentDiv && this.loginField && this.loginField.value && this.loginField.value !== 'undefined') {
                var passwordValidator = new Greenmile.Components.PasswordValidator(
                    this.loginField.value,
                    this.newField,
                    this.newConfirmField,
                    this.changePassBtn,
                    this.entity
                ).render();
                
                this.formDiv.insertBefore(passwordValidator , this.newConfirmLabel);
            }
        };

        this.hideCurrentField = function () {
            this.currentField.style.display = 'none';
            this.currentLabel.style.display = 'none';
        };

        this.destroy = function () {
            const container = this.contentDiv.parentNode;
            container.removeChild(this.contentDiv);
        };

        this.init = function (container) {
            var allowChangePassword = function (element) {
                return (element.key === "USER_CHANGE_PASSWORD");
            };

            var checkPermissions = function () {
                return (Monet.Session.Security.permissions
                  && Monet.Session.Security.permissions.some(allowChangePassword));
            };

            if ((!Monet.Session.isLogged || checkPermissions()) &&
                !this.contentDiv) 
            {
                this.createHtml();
                this.addEvents();
                container.appendChild(this.contentDiv);
            }
            return this.contentDiv;
        };

        return this;
    };
}());